import { usePageTitle } from "../hooks/usePageTitle";
import TestimonialSection from "../components/HomepageSection/TestimonialSection";
import Footer from "../components/Footer";

// Icons
import homeIcon from "../svg/home-icon.svg";
import carIcon from "../svg/car-icon.svg";
import workersIcon from "../svg/workerscomp-icon.svg";
import genLiabilityIcon from "../svg/genliability-icon.svg";
import proLiabilityIcon from "../svg/proliability-icon.svg";
import eventIcon from "../svg/event-icon.svg";
import commercialAutoIcon from "../svg/commercialauto-icon.svg";
import moreIcon from "../svg/more-icon.svg";
import floodIcon from "../svg/flood-icon.svg";
import umbrellaIcon from "../svg/umbrella-icon.svg";
import rentersIcon from "../svg/renters-icon.svg";
import businessIcon from "../svg/business-icon.svg";
import earthquakeIcon from "../svg/earthquake-icon.svg";
import boatIcon from "../svg/boat-icon.svg";

// Images
import genliabImg from "../assets/insurancelines/genLiab.png";
import profliabImg  from "../assets/insurancelines/profLiab.png";
import workersImg  from "../assets/insurancelines/workers.png";
import homeImg from "../assets/insurancelines/home.png";
import perautoImg from "../assets/insurancelines/personalauto.png";
import commautoImg from "../assets/insurancelines/commauto.png";
import businessImg from "../assets/insurancelines/business.png";
import rentersImg from "../assets/insurancelines/renters.png";
import umbrellaImg from "../assets/insurancelines/umbrella.png";
import floodImg from "../assets/insurancelines/flood.png";
import earthquakeImg from "../assets/insurancelines/earthquake.png";
import specialeventImg from "../assets/insurancelines/specialevent.png";
import boatImg from "../assets/insurancelines/boat.png";
import moreImg from "../assets/insurancelines/more.png";

// Minimal stroke icons for lines without imported assets
const Icons = {
  business: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="1" />
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      <line x1="12" y1="12" x2="12" y2="16" />
      <line x1="10" y1="14" x2="14" y2="14" />
    </svg>
  ),
  health: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
  ),
  travel: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3.07 4.18 2 2 0 0 1 5.07 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 23 17z" />
    </svg>
  ),
  renters: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
      <path d="M8 21v-8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8" />
      <circle cx="12" cy="10" r="1.5" />
    </svg>
  ),
  umbrella: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M23 12a11 11 0 0 0-22 0" />
      <path d="M12 12v6a2 2 0 0 0 4 0" />
    </svg>
  ),
  disability: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="5" r="2" />
      <path d="M12 7v6l3 3" />
      <path d="M9 21a6 6 0 1 0 9.33-7.41" />
    </svg>
  ),
  flood: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 18c0-1 .7-2 2-2s2 1 2 2 .7 2 2 2 2-1 2-2 .7-2 2-2 2 1 2 2 .7 2 2 2 2-1 2-2" />
      <path d="M3 13c0-1 .7-2 2-2s2 1 2 2 .7 2 2 2 2-1 2-2 .7-2 2-2 2 1 2 2 .7 2 2 2 2-1 2-2" />
      <path d="M12 3v5" />
      <path d="M9 6l3-3 3 3" />
    </svg>
  ),
  identity: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <circle cx="8" cy="12" r="2" />
      <path d="M13 10h5" />
      <path d="M13 14h3" />
    </svg>
  ),
};

const lines = [
  {
  title: "General Liability Insurance", 
  icon: genLiabilityIcon,
  image: genliabImg,
  description:
    "Protect your business from third-party claims involving bodily injury, property damage, and personal or advertising injury.",
  },
  {
  title: "Professional Liability (E&O)", 
  icon: proLiabilityIcon,
  image: profliabImg,
  description:
    "Protect your business against claims of negligence, misrepresentation, or inaccurate advice. Essential for individuals and companies providing professional services.",
  },
  {
    title: "Worker's Compensation Insurance", 
    icon: workersIcon,
    image: workersImg,
    description:
      "Protect your employees and your business. Cover medical expenses, lost wages, and rehabilitation costs for work-related injuries or illnesses.",
  },
  {
    title: "Homeowners Insurance", 
    icon: homeIcon,
    image: homeImg,
    description:
      "Protect your most valuable asset. Get comprehensive home insurance coverage with Paladin and safeguard your home against unexpected damage or loss.",
  },
  {
    title: "Personal Auto Insurance", 
    icon: carIcon,
    image: perautoImg,
    description:
      "Drive with peace of mind. Paladin offers a range of auto insurance policies to cover you and your vehicle against accidents, theft, and other unforeseen risks.",
  },
  {
  title: "Commercial Auto Insurance", 
  icon: commercialAutoIcon,
  image: commautoImg,
  description:
    "Protect the vehicles your business uses every day. Coverage includes liability, collision, comprehensive, and cargo protection for company cars, trucks, and vans.",
  },
  {
    title: "Business Insurance",
    icon: businessIcon,
    image: businessImg,
    description:
      "Protect your business from unexpected events. Paladin offers customized insurance solutions to cover your business against risks and liabilities.",
  },
  {
    title: "Renters Insurance",
    icon: rentersIcon,
    image: rentersImg,
    description:
      "Protect your belongings and liability as a renter. Our policies cover theft, fire, water damage, and more.",
  },
  {
    title: "Umbrella Insurance",
    icon: umbrellaIcon,
    image: umbrellaImg,
    description:
      "Get additional liability coverage beyond your existing policies. Extra protection for your assets and peace of mind.",
  },
  {
    title: "Flood Insurance",
    icon: floodIcon,
    image: floodImg,
    description:
      "Protect your home and belongings from flood damage. Coverage for natural disasters, burst pipes, and water-related incidents.",
  },
  {
    title: "Eathquake Insurance",
    icon: earthquakeIcon,
    image: earthquakeImg,
    description:
      "Protect your property from earthquake damage. Coverage includes structural repairs, rebuilding costs, and loss of personal belongings caused by seismic activity.",
  },
  {
  title: "Special Event Insurance",
  icon: eventIcon,
  image: specialeventImg,
  description:
    "Cover your specific occasions against unexpected cancellations, property damage, and liability claims. Perfect for corporate events, conferences, and special celebrations.",
  },
  {
  title: "Boat Insurance",
  icon: boatIcon,
  image: boatImg,
  description:
    "Protect your boat against accidents, theft, and unexpected damage with coverage tailored for recreational and commercial vessels.",
  },
  {
  title: "And Many More",
  icon: moreIcon,
  image: moreImg,
  description:
    "Whatever your risks, we have you covered. Contact us today to discover our complete range of insurance solutions.",
  },
];

function InsuranceCard({ line }) {
  return (
    <div
      className="bg-white-pure rounded-sm flex flex-col group cursor-pointer"
      style={{ boxShadow: "0 2px 12px rgba(1,46,114,0.08)" }}
    >
      {/* Image */}
      <div className="relative w-full" style={{ height: "200px" }}>
        <img
          src={line.image}
          alt={line.title}
          className="w-full h-full object-cover rounded-t-sm"
        />
        {/* Icon badge straddling image and content */}
        <div
          className="absolute -bottom-6 right-6 flex items-center justify-center rounded-sm z-10"
          style={{ width: "52px", height: "52px", backgroundColor: "#012E72" }}
        >
          {typeof line.icon === "string" ? (
            <img
              src={line.icon}
              alt=""
              className="w-7 h-7 object-contain"
              style={{ filter: "brightness(0) invert(1)" }}
            />
          ) : (
            line.icon
          )}
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 px-6 pt-9 pb-6">
        <p className="font-cinzel text-xs tracking-widest uppercase text-blue-primary mb-2">
          Insurance Line
        </p>
        <h3 className="font-constantia text-blue-dark text-xl font-bold mb-2">
          {line.title}
        </h3>
        <div className="w-8 h-px bg-blue-primary mb-3" />
        <p className="font-times text-black-deep text-sm leading-relaxed flex-1">
          {line.description}
        </p>
        <span
          className="font-times text-sm mt-4 group-hover:underline"
          style={{ color: "#012E72" }}
        >
        </span>
      </div>
    </div>
  );
}

export default function OurServicesPage() {
  usePageTitle("Our Services");
  return (
    <div className="w-full">
      <main className="bg-white-pure">

        {/* ── What We Cover ── */}
        <section className="w-full bg-white-warm py-24 px-8 md:px-16">
          <div className="max-w-6xl mx-auto">

            {/* Section label */}
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-blue-dark" />
              <span className="font-cinzel text-xs tracking-widest uppercase text-blue-dark">
                What We Cover
              </span>
            </div>

            {/* Heading */}
            <h2 className="font-cinzel text-4xl md:text-6xl font-bold text-blue-dark leading-tight mb-4">
              Our{" "}
              <span className="font-constantia italic font-normal">Insurance</span>{" "}
              Lines
            </h2>

            {/* Subheading */}
            <p
              className="font-times text-black-deep text-base leading-relaxed max-w-xl mb-16"
              style={{ opacity: 0.7 }}
            >
              Paladin serves a wide range of clients across multiple insurance lines.
              Each policy is crafted around your specific needs and risk profile.
            </p>

            {/* Cards grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {lines.map((line) => (
                <InsuranceCard key={line.title} line={line} />
              ))}
            </div>

            {/* CTA */}
            <div className="flex justify-start mt-14">
              <button className="bg-blue-dark text-white-pure font-cinzel text-xs tracking-widest uppercase px-10 py-4 hover:bg-blue-primary transition-colors duration-300 rounded-sm">
                Request a Quote
              </button>
            </div>
          </div>
        </section>

        {/* ── Testimonials ── */}
        <TestimonialSection />

        {/* ── Not Sure What Insurance To Take ── */}
        <section className="w-full bg-white-warm py-20 px-8 md:px-16">
          <div className="max-w-6xl mx-auto">
            <div
              className="bg-white-pure rounded-sm border border-blue-dark border-opacity-10 overflow-hidden"
              style={{ boxShadow: "0 2px 24px rgba(1,46,114,0.08)" }}
            >
              {/* Top accent bar */}
              <div className="w-full h-1 bg-blue-dark" />

              <div className="px-10 md:px-16 py-16 flex flex-col md:flex-row items-start md:items-center gap-10">

                {/* Left: text */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-5">
                    <div className="h-px w-8 bg-blue-dark" />
                    <span className="font-cinzel text-xs tracking-widest uppercase text-blue-dark">
                      Need Guidance?
                    </span>
                  </div>
                  <h2 className="font-cinzel text-3xl md:text-4xl font-bold text-blue-dark leading-tight mb-4">
                    Not Sure What{" "}
                    <span className="font-constantia italic font-normal">Insurance</span>{" "}
                    to Take?
                  </h2>
                  <div className="w-10 h-px bg-blue-primary mb-5" />
                  <p
                    className="font-times text-black-deep text-base leading-relaxed max-w-md"
                    style={{ opacity: 0.75 }}
                  >
                    Talk with our team for personalized guidance and get the right
                    coverage based on your needs and budget.
                  </p>
                </div>

                {/* Right: buttons */}
                <div className="flex flex-col gap-3 shrink-0">
                  <button className="bg-blue-dark text-white-pure font-cinzel text-xs tracking-widest uppercase px-10 py-4 rounded-sm hover:bg-blue-primary transition-colors duration-300">
                    Personalized Consultation
                  </button>
                  <button className="border border-blue-dark text-blue-dark font-cinzel text-xs tracking-widest uppercase px-10 py-4 rounded-sm hover:bg-blue-dark hover:text-white-pure transition-colors duration-300">
                    Contact Us Directly
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
}